import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "./components/AppLayout";
import FireOnPage from "./pages/FireOnPage";

export default function Main() {
  return (
    <AppLayout>
      <Routes>
        <Route path="fire-on/*" element={<FireOnPage />} />
        <Route path="*" element={<Navigate to="/fire-on/" />} />
      </Routes>
    </AppLayout>
  );
}
